import { LOTUS_SHAPES } from "@/lib/lotus";

// The lotus as line-work — a decorative ghost motif for inner pages.
// Renders the same petal geometry as the hero mask, as a fine gold outline.
const GhostLotus = ({ className = "", style = {} }) => (
  <svg
    viewBox="0 0 1000 950"
    aria-hidden="true"
    className={`pointer-events-none ${className}`}
    style={style}
    fill="none"
  >
    <g
      stroke="currentColor"
      strokeWidth="6"
      dangerouslySetInnerHTML={{
        __html: LOTUS_SHAPES.map((s) => s.replace("fill='white'", "")).join(""),
      }}
    />
  </svg>
);

export default GhostLotus;
